<template>
<div>
  <!-- {{products}} -->
  <div v-if="products" class="column">
    <!-- <q-infinite-scroll ref="infiniteScroll" @load="loadMoreItems" :offset="250"> -->
      <!-- <q-scroll-observer @scroll="onScroll" /> -->
      <div class="row justify-center col" style="margin: 0; padding: 0;">
        <div class="row q-gutter-md q-ma-none justify-center" ref="cardContainer" style="width: 100%;">
          <product-card v-for="product in products" :key="product.id" :product="product" :store-type="storeType" :scrollInfo="scrollInfo" />
        </div>
      </div>
      <!-- <template v-slot:loading>
        <div v-if="!finished" class="row justify-center col q-my-lg">
          <q-spinner-dots color="primary" size="5em" />
        </div>
      </template> -->
    <!-- </q-infinite-scroll> -->
    <div v-if="finished" class="row flex-center">
      <div class="col-auto">
        <hr style="width: 30vw; margin-bottom: 20px;"/>
      </div>
    </div>
  </div>
</div>

</template>

<script>
import ProductCard from '../components/ProductCard'
import { scroll } from 'quasar'
import { mapState } from 'vuex'
const { setScrollPosition, getScrollTarget } = scroll

export default {
  name: 'ProductGrid',
  components: {
    'product-card': ProductCard
  },
  props: {
    products: Array,
    storeType: String
  },
  // watch: {
  //   filters: {
  //     deep: true,
  //     handler (newVal, oldVal) {
  //       setScrollPosition(getScrollTarget(this.$el), 0, 1000)
  //       // If filters computed property changes, set total products showing back to 4 rows
  //       this.totalProductsShowing = this.getItemsPerRow() * 4
  //       this.$refs.infiniteScroll.reset()
  //       this.$refs.infiniteScroll.resume()
  //       this.finished = false
  //     }
  //   },
  //   search (newVal, oldVal) {
  //     setScrollPosition(getScrollTarget(this.$el), 0, 1000)
  //     // If search computed property changes, set total products showing back to 4 rows
  //     this.totalProductsShowing = this.getItemsPerRow() * 4
  //     this.$refs.infiniteScroll.reset()
  //     this.$refs.infiniteScroll.resume()
  //     this.finished = false
  //   }
  // },
  computed: {
    ...mapState('filters', ['filters', 'search']),
    displayedProducts () {
      return this.products.slice(0, this.totalProductsShowing)
    }
  },
  data () {
    return {
      // Start with zero, loadMoreItems is called once on init so we really start with 8
      totalProductsShowing: 0,
      finished: false,
      scrollInfo: {},
    }
  },
  methods: {
    onScroll(info){
      this.scrollInfo = info;
    },
    getItemsPerRow () {
      const nodes = this.$refs.cardContainer?.children || []
      const containerWidth = this.$refs.cardContainer.offsetWidth
      if (nodes.length > 0) {
        const margin = Number(window.getComputedStyle(nodes[0]).marginLeft.replace('px', '')) || 0
        const itemWidth = nodes[0].offsetWidth
        return Math.floor((containerWidth - 32) / (itemWidth + margin))
      } else {
        // Estimate
        const sizeChangeAfterInit = 13 // The size of the cardContainer changes slightly between having no elements and after
        const containerMargin = 32
        const itemWidth = 260
        const itemMargin = 16
        return Math.floor((containerWidth + sizeChangeAfterInit - containerMargin) / (itemWidth + itemMargin))
      }
    },
    loadMoreItems (index, done) {
      const hijackedDone = (finished) => {
        done(finished)
        this.finished = finished
      }
      this.$emit('loadMore', hijackedDone)
      // this.$emit('loadMore', done)
      // const rowsShowing = Math.ceil(this.totalProductsShowing / this.getItemsPerRow())
      // this.totalProductsShowing = (rowsShowing + 2) * this.getItemsPerRow()
      // if (this.totalProductsShowing >= this.products.length) {
      //   // Stop scrolling
      //   done(true)
      // } else {
      //   setTimeout(() => done(), 1000)
      // }
    }
  }
}
</script>

<style scoped>

</style>
